{
  "nameInput": {
    "placeholder": "Adınız nedir?"
  },
  "signIn": {
    "tagline": "Niyetle başla.",
    "signingIn": "Giriş yapılıyor…",
    "continueApple": "Apple ile devam et",
    "continueApple_aria": "Apple ile devam et",
    "continueGoogle": "Google ile devam et",
    "continueGoogle_aria": "Google ile devam et",
    "logo_alt": "Rhemn",
    "footer": "Giriş yaparak hizmet şartlarımızı ve <privacyLink>Gizlilik Politikamızı</privacyLink> kabul etmiş olursunuz.",
    "divider": "veya"
  },
  "email": {
    "identity": {
      "label": "E-posta adresi",
      "placeholder": "you@example.com",
      "change": "Değiştir",
      "change_aria": "E-posta adresini değiştir"
    },
    "password": {
      "label": "Parola",
      "labelNew": "Bir parola seçin",
      "placeholder": "Parola",
      "placeholderNew": "Bir parola oluşturun",
      "show": "Parolayı göster",
      "hide": "Parolayı gizle"
    },
    "actions": {
      "continue": "Devam et",
      "signIn": "Giriş yap",
      "createAccount": "Hesap oluştur",
      "forgot": "Parolanızı mı unuttunuz?",
      "backToSignIn": "Girişe dön",
      "iVerified": "E-postamı doğruladım",
      "resend": "Bağlantıyı yeniden gönder",
      "resendIn": "{{time}} içinde yeniden gönder",
      "signInInstead": "Giriş yap"
    },
    "busy": {
      "checking": "Kontrol ediliyor…",
      "signingIn": "Giriş yapılıyor…",
      "creating": "Hesabınız oluşturuluyor…",
      "sending": "Gönderiliyor…"
    },
    "switch": {
      "toCreate": "Rhemn’de yeni misiniz? <switchBtn>Hesap oluşturun</switchBtn>",
      "toSignIn": "Zaten hesabınız var mı? <switchBtn>Giriş yapın</switchBtn>"
    },
    "strength": {
      "tooShort": "En az 12 karakter.",
      "level1": "İyi. Uzun olan daha güçlüdür.",
      "level2": "Güçlü parola.",
      "level3": "Çok güçlü parola."
    },
    "sent": {
      "title": "Gelen kutunuzu kontrol edin",
      "body": "{{email}} adresine bir sıfırlama bağlantısı gönderdik. Bir saat içinde geçerliliğini yitirir.",
      "resent": "Yeniden gönderildi. Gelen kutunuzu kontrol edin."
    },
    "verify": {
      "title": "E-postanızı doğrulayın",
      "body": "{{email}} adresine bir bağlantı gönderdik. Hesabınızın kurulumunu tamamlamak için bağlantıyı açın; buradan otomatik olarak devam edeceğiz.",
      "waiting": "Bağlantıyı açmanız bekleniyor…",
      "resent": "Yeniden gönderildi. Gelen kutunuzu kontrol edin."
    },
    "errors": {
      "invalidEmail": "Bu bir e-posta adresine benzemiyor.",
      "missingPassword": "Parolanızı girin.",
      "invalidCredential": "E-posta veya parola hatalı.",
      "emailInUse": "Bu e-postanın zaten bir hesabı var. <signInBtn>Giriş yapın.</signInBtn>",
      "weakPassword": "En az 12 karakter kullanın.",
      "passwordTooShort": "En az 12 karakter kullanın.",
      "passwordCommon": "Bu parolanın tahmin edilmesi çok kolay. Daha öngörülemez bir şey deneyin.",
      "emailNotVerified": "Devam etmeden önce e-postanızı doğrulayın.",
      "providerGoogle": "Bu e-posta zaten Google ile kurulmuş. Aşağıdan Google ile devam edin.",
      "providerApple": "Bu e-posta zaten Apple ile kurulmuş. Aşağıdan Apple ile devam edin.",
      "userDisabled": "Bu hesap devre dışı bırakıldı.",
      "requiresRecentLogin": "Bu değişikliği yapmak için yeniden giriş yapın.",
      "sessionExpired": "Oturumunuzun süresi doldu. Yeniden giriş yapın.",
      "expiredActionCode": "Bu bağlantının süresi doldu. Yenisini isteyin.",
      "invalidActionCode": "Bu bağlantı artık geçerli değil. Yenisini isteyin.",
      "tooManyRequests": "Çok fazla deneme. Birkaç dakika bekleyin veya parolanızı sıfırlayın.",
      "network": "Bağlantı yok. Ağınızı kontrol edip tekrar deneyin.",
      "operationNotAllowed": "E-posta ile giriş şu anda kullanılamıyor.",
      "generic": "Bir şeyler ters gitti. Lütfen tekrar deneyin."
    },
    "a11y": {
      "stepEmail": "2 adımdan 1. adım. E-posta adresinizi girin.",
      "stepPasswordSignIn": "2 adımdan 2. adım. Giriş yapmak için parolanızı girin.",
      "stepPasswordCreate": "2 adımdan 2. adım. Yeni hesabınız için bir parola seçin.",
      "stepSent": "Sıfırlama bağlantısı gönderildi. Gelen kutunuzu kontrol edin.",
      "stepVerify": "Hesap oluşturuldu. Doğrulama bağlantısı gönderildi.",
      "resendReady": "Bağlantıyı şimdi yeniden gönderebilirsiniz."
    }
  }
}
